import { render, staticRenderFns } from "./BotaoBusca.vue?vue&type=template&id=3cd20bc0&scoped=true&"
import script from "./BotaoBusca.vue?vue&type=script&lang=js&"
export * from "./BotaoBusca.vue?vue&type=script&lang=js&"
import style0 from "./BotaoBusca.vue?vue&type=style&index=0&id=3cd20bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd20bc0",
  null
  
)

export default component.exports